// extracted by mini-css-extract-plugin
module.exports = {"card":"clinical-portal-3__CallRecording__card"};